import r, { keyframes as n } from "styled-components";
const t = n`
  100% { transform: translateX(100%); }
`, a = r.div`
  background-color: ${({ theme: o }) => o == null ? void 0 : o.get("tokens.colors.skeleton.bkg")};
  height: ${({ $height: o }) => typeof o == "number" ? `${o}px` : o};
  overflow: hidden;
  position: relative;
  width: ${({ $width: o }) => typeof o == "number" ? `${o}px` : o};

  &::after {
    animation: ${t} 3s infinite;
    background-image: linear-gradient(
      90deg,
      rgb(255 255 255/0) 0%,
      rgb(255 255 255/0.2) 20%,
      rgb(255 255 255/0.5) 60%,
      rgb(255 255 255/0)
    );
    content: '';
    inset: 0;
    position: absolute;
    transform: translateX(-100%);
  }
`;
export {
  a as SkeletonRow
};
